import React, { CSSProperties } from "react";
import { SPColor } from "../../constants/color";
import { MoonLoader } from "react-spinners";

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

export default function Loading({ size = 100 }) {
  return (
    <MoonLoader
      color={SPColor.DARK_BLUE}
      loading={true}
      cssOverride={override}
      size={size}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  );
}
